import * as Sentry from "@sentry/react";
import { replay } from "index";

import store from "../redux-store";
import { MILI_SECS_IN_ONE_SEC } from "./constants";
const isCaptureEvent = true; // isProdEnv;

// Moved to @rista/core/utils/sentryHelpers. Re-export only — this file's own body does not read
// it (ledger rule 5). Only the NAMES moved; sendCaptureEvent below stays here, because it needs
// @sentry/react and the `replay` instance from the app entry.
export { SENTRY_EVENTS } from "@rista/core/utils/sentryHelpers";

export async function sendCaptureEvent(data = {}, id = "fulfillmentUpdate", saleId = "", businessName = "") {
  if (!isCaptureEvent) return;
  const currentBusiness = store.getState().businessStore?.businessData?.businessName;
  if (businessName.length && currentBusiness !== businessName) { //only send event for this business
    return;
  }
  const businessStore = store.getState()?.businessStore;
  let tags = {
    saleId,
    id: id,
    branchId: businessStore?.businessData?.branchId,
    groupId: businessStore?.businessData?.groupId,
    userId: businessStore?.userData?.userId || "",
    businessUserId: businessStore?.userData?.businessUserId || "",
  };
  Sentry.setTags(tags);
  try {
    replay.start();
  } catch (err) {
    //replay already in progress
  }
  Sentry.setExtras({ data: JSON.stringify(data)});
  console.log(`[Sentry Event] ${id}`, { saleId, data, tags });
  Sentry.captureEvent({
    message: id,
    level: "log",
    tags,
  });
  setTimeout(async () => {
    await replay.flush();
    await replay.stop();
  }, 10 * MILI_SECS_IN_ONE_SEC);
}

/**
 * 
 * @returns limited post settings data to be sent as logs
 */
export function getPosSettingsData() {
  const posSettings = store.getState().catalogStore?.posSettings;
  return { version: posSettings.version, tickets: posSettings.tickets };
}